import { createAction, emptyProps, props } from '@ngrx/store';

export const FETCHED_TENANT_LIST = createAction(
  'P_FETCHEDTENANTLIST',
  props<{ accessed_tenant: any }>(),
);

export const FETCHED_TENANT_DETAILS = createAction(
  'P_FETCHEDTENANTDETAILS',
  props<{ selected_tenant: any }>(),
);

export const ERROR_TENANT_LIST = createAction(
  'P_ERRORTENANTLIST',
  props<{ err: any }>(),
);

export const STATSIG_INITIALIZE = createAction(
  'STATSIG_INITIALIZE',
  emptyProps,
);

// for unauthorized ... // TODO ..
export const STATSIG_UPDATE_USER = createAction(
  'STATSIG_UPDATE_USER',
  props<{ selected_tenant: any }>(),
);

export const STATSIG_UPDATE_USER_SUCCESS = createAction(
  'STATSIG_UPDATE_USER_SUCCESS',
  props<{ user: any }>(),
);

export const FETCH_CURRENT_LOCATION = createAction(
  'FETCH_CURRENT_LOCATION',
  emptyProps,
);

export const FETCHED_CURRENT_LOCATION = createAction(
  'FETCHED_CURRENT_LOCATION',
  props<{ location?: any }>(),
);

export const ERROR_CURRENT_LOCATION = createAction(
  'ERROR_CURRENT_LOCATION',
  props<{ error: any }>(),
);
